define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action/Switchboard",
	"csi/def/Relationship",
	"csi/def/Toolbar",
	"csi/prefs/_base",
	"csi/property/Widget",
	"csi/view/ToolbarPluginSwitchboard",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType"
], function(declare, lang, _, SwitchboardAction, Relationship, Toolbar, csiPrefs, Widget, SwitchboardPlugin, xml, Query, ProductType) {

	const TYPES = {
		Material: {
			id: "MaterialType",
			type: "MaterialType"
		},

		Style: {
			id: "StyleType",
			type: "StyleType"
		}
	};

	const _Switchboard = declare(SwitchboardPlugin, {
		resDefault: "SelectAll",
		style: "margin: 0 3px",

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: update prefNodeContext with name of ProductType
			view.prefNodeContext = node ? node.$Name : null;
		},

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: create relationship for published ProductTypes
			r = r || lang.mixin(new Relationship(), {
				m_typeNode: this.actionToolbar.view._catalogParams.type,
				m_query: new Query()
					.Attr("Published", xml.OP_EQUALS, true)
					.Attr("Available", xml.OP_EQUALS, true, "Child:ProductionConfig")
			});

			return this.inherited(arguments, [url, r]);
		}
	});

	return declare(Widget, {
		customViewOptionsComponent: null,
		disableCustomViewToolbar: true,

		// String[]: reset plugins to be filled in later
		plugins: [],

		// Boolean: indicate we only want to work with shared custom views
		prefSiteOnly: true,

		// String: specify empty context to override default Html view context so that Catalog view will find default
		prefViewContext: "",

		// Object: parameters for view
		_catalogParams: null,

		getCustomViewNodeContextsStore: function() {
			// summary: return store of product types
			return ProductType.store(this._catalogParams.type);
		},

		onViewToolbar: function(/*Toolbar*/tb) {
			// summary: revert back to base csi.view.Widget
			var plugin = tb.getPlugin("views");
			if (plugin && plugin.buttonNode)
				plugin.buttonNode.set("label", _.escape(csiPrefs.optionResource("ForType")));
		},

		setViewNode: function(/*Node*/node, /*Boolean*/bSaveSelections) {
			// summary: prefNodeContext needs to vary based on product type
			this._catalogParams = TYPES[this.defView.getTypeNode()];
			this.prefNodeContext = ProductType.name(node, this._catalogParams.id);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Custom views are enabled even though disabling standard custom view toolbar controls
		 */
		supportsCustomViews: function() {
			return true;
		},

		_resolveView: function() {
			// summary: add toolbar plugin to select style type if in configuration view
			if (!this.getViewNode()) {
				this.defView.defToolbar = lang.mixin(new Toolbar(), {
					m_actions: [
						lang.mixin(new SwitchboardAction(), {
							m_id: "SelectProductType",
							classToolbarPlugin: _Switchboard,
							classController: "csi/view/RefreshCustomViewController"
						}),
						"|",
						"CustomViewManageButton",
						"CustomViewSelect"
					]
				});
			}

			this.inherited(arguments);
		}
	});
});